var map = {
	"./sample.abap.txt": [
		9078,
		9078
	],
	"./sample.aes.txt": [
		8951,
		8951
	],
	"./sample.apex.txt": [
		3699,
		3699
	],
	"./sample.azcli.txt": [
		4041,
		4041
	],
	"./sample.bat.txt": [
		739,
		739
	],
	"./sample.bicep.txt": [
		6540,
		6540
	],
	"./sample.brainfuck.txt": [
		831,
		831
	],
	"./sample.c.txt": [
		6489,
		6489
	],
	"./sample.cameligo.txt": [
		9069,
		9069
	],
	"./sample.clike.txt": [
		6210,
		6210
	],
	"./sample.clojure.txt": [
		7428,
		7428
	],
	"./sample.coffeescript.txt": [
		7726,
		7726
	],
	"./sample.cpp.txt": [
		9090,
		9090
	],
	"./sample.csharp.txt": [
		3551,
		3551
	],
	"./sample.csp.txt": [
		1676,
		1676
	],
	"./sample.css.txt": [
		3356
	],
	"./sample.dart.txt": [
		4168,
		4168
	],
	"./sample.dockerfile.txt": [
		5443,
		5443
	],
	"./sample.ecl.txt": [
		56,
		56
	],
	"./sample.elixir.txt": [
		1325,
		1325
	],
	"./sample.erlang.txt": [
		521,
		521
	],
	"./sample.flow9.txt": [
		9402,
		9402
	],
	"./sample.freemarker2.txt": [
		9798,
		9798
	],
	"./sample.fsharp.txt": [
		995,
		995
	],
	"./sample.go.txt": [
		7252
	],
	"./sample.graphql.txt": [
		3700,
		3700
	],
	"./sample.handlebars.txt": [
		6591,
		6591
	],
	"./sample.hcl.txt": [
		2791,
		2791
	],
	"./sample.html.txt": [
		7548
	],
	"./sample.ini.txt": [
		5775,
		5775
	],
	"./sample.java.txt": [
		2085
	],
	"./sample.javascript.txt": [
		8530
	],
	"./sample.json.txt": [
		2877
	],
	"./sample.jsx.txt": [
		3346
	],
	"./sample.julia.txt": [
		9107,
		9107
	],
	"./sample.kotlin.txt": [
		7893,
		3759
	],
	"./sample.less.txt": [
		2388,
		2388
	],
	"./sample.lex.txt": [
		7338,
		7338
	],
	"./sample.lexon.txt": [
		1072,
		1072
	],
	"./sample.liquid.txt": [
		6220,
		6220
	],
	"./sample.livescript.txt": [
		9279,
		9279
	],
	"./sample.lua.txt": [
		6394,
		6394
	],
	"./sample.m3.txt": [
		3054,
		9084
	],
	"./sample.markdown.txt": [
		8194
	],
	"./sample.mips.txt": [
		57,
		4910
	],
	"./sample.msdax.txt": [
		480,
		480
	],
	"./sample.mysql.txt": [
		65
	],
	"./sample.nginx.txt": [
		1177,
		1177
	],
	"./sample.objective-c.txt": [
		6644,
		6644
	],
	"./sample.pascal.txt": [
		9241,
		9241
	],
	"./sample.pascaligo.txt": [
		290,
		290
	],
	"./sample.perl.txt": [
		2255,
		2255
	],
	"./sample.pgsql.txt": [
		1348,
		1348
	],
	"./sample.php.txt": [
		1957
	],
	"./sample.pla.txt": [
		4609,
		4609
	],
	"./sample.plaintext.txt": [
		2524,
		2524
	],
	"./sample.postiats.txt": [
		8302,
		8302
	],
	"./sample.powerquery.txt": [
		7378,
		7378
	],
	"./sample.powershell.txt": [
		1565,
		1565
	],
	"./sample.proto.txt": [
		5583,
		5583
	],
	"./sample.pug.txt": [
		6876,
		6876
	],
	"./sample.python.txt": [
		7475
	],
	"./sample.qsharp.txt": [
		1694,
		7893
	],
	"./sample.r.txt": [
		8583,
		8583
	],
	"./sample.razor.txt": [
		4247,
		4247
	],
	"./sample.redis.txt": [
		4333,
		4333
	],
	"./sample.redshift.txt": [
		9878,
		9878
	],
	"./sample.restructuredtext.txt": [
		5273,
		5273
	],
	"./sample.ruby.txt": [
		8366,
		8366
	],
	"./sample.rust.txt": [
		1233
	],
	"./sample.sb.txt": [
		3092,
		3092
	],
	"./sample.scala.txt": [
		1760,
		1760
	],
	"./sample.scheme.txt": [
		1249,
		1249
	],
	"./sample.scss.txt": [
		799,
		799
	],
	"./sample.shell.txt": [
		6624
	],
	"./sample.sol.txt": [
		1899,
		1899
	],
	"./sample.sparql.txt": [
		8203,
		8203
	],
	"./sample.sql.txt": [
		3512,
		9952
	],
	"./sample.st.txt": [
		9236,
		9236
	],
	"./sample.stylus.txt": [
		4005,
		4005
	],
	"./sample.swift.txt": [
		4775
	],
	"./sample.systemverilog.txt": [
		1094,
		1094
	],
	"./sample.tcl.txt": [
		6300,
		6300
	],
	"./sample.toml.txt": [
		7636,
		7636
	],
	"./sample.tsx.txt": [
		7587
	],
	"./sample.twig.txt": [
		616,
		616
	],
	"./sample.typescript.txt": [
		8186
	],
	"./sample.vb.txt": [
		3610,
		3610
	],
	"./sample.vbscript.txt": [
		321,
		321
	],
	"./sample.verilog.txt": [
		9049,
		9049
	],
	"./sample.vue.txt": [
		8314,
		8314
	],
	"./sample.xml.txt": [
		750,
		750
	],
	"./sample.yaml.txt": [
		7410,
		7410
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 620;
module.exports = webpackAsyncContext;